// import earth_mask from "../planet/compressed-assets/desktop/earth_mask.png";
// import earth_texture from "../planet/compressed-assets/desktop/earth_texture.jpg";

import moon_mask from "../planet/compressed-assets/desktop/moon_mask.png";
import moon_texture from "../planet/compressed-assets/desktop/moon_texture.jpg";

import mars_mask from "../planet/compressed-assets/desktop/mars_mask.png";
import mars_texture from "../planet/compressed-assets/desktop/mars_texture.jpg";

import jupiter_mask from "../planet/compressed-assets/desktop/jupiter_mask.png";
import jupiter_texture from "../planet/compressed-assets/desktop/jupiter_texture.jpg";

import neptune_mask from "../planet/compressed-assets/desktop/neptune_mask.png";
import neptune_texture from "../planet/compressed-assets/desktop/neptune_texture.jpg";

import saturn_texture from "../planet/compressed-assets/desktop/saturn_texture.jpg";
import saturn_mask from "../planet/compressed-assets/desktop/saturn_mask.png";

import uranus_mask from "../planet/compressed-assets/desktop/uranus_mask.png";
import uranus_texture from "../planet/compressed-assets/desktop/uranus_texture.jpg";

// import earth_mask_mobile from "../planet/compressed-assets/mobile/earth_mask.png";
// import earth_texture_mobile from "../planet/compressed-assets/mobile/earth_texture.jpg";

import moon_mask_mobile from "../planet/compressed-assets/mobile/moon_mask.png";
import moon_texture_mobile from "../planet/compressed-assets/mobile/moon_texture.jpg";

import mars_mask_mobile from "../planet/compressed-assets/mobile/mars_mask.png";
import mars_texture_mobile from "../planet/compressed-assets/mobile/mars_texture.jpg";

import jupiter_mask_mobile from "../planet/compressed-assets/mobile/jupiter_mask.png";
import jupiter_texture_mobile from "../planet/compressed-assets/mobile/jupiter_texture.jpg";

import neptune_mask_mobile from "../planet/compressed-assets/mobile/neptune_mask.png";
import neptune_texture_mobile from "../planet/compressed-assets/mobile/neptune_texture.jpg";

import saturn_texture_mobile from "../planet/compressed-assets/mobile/saturn_texture.jpg";
import saturn_mask_mobile from "../planet/compressed-assets/mobile/saturn_mask.png";

import uranus_mask_mobile from "../planet/compressed-assets/mobile/uranus_mask.png";
import uranus_texture_mobile from "../planet/compressed-assets/mobile/uranus_texture.jpg";

// import earth_mask_mobilelow from "../planet/compressed-assets/mobilelow/earth_mask.png";
// import earth_texture_mobilelow from "../planet/compressed-assets/mobilelow/earth_texture.jpg";

import moon_mask_mobilelow from "../planet/compressed-assets/mobilelow/moon_mask.png";
import moon_texture_mobilelow from "../planet/compressed-assets/mobilelow/moon_texture.jpg";

import mars_mask_mobilelow from "../planet/compressed-assets/mobilelow/mars_mask.png";
import mars_texture_mobilelow from "../planet/compressed-assets/mobilelow/mars_texture.jpg";

import jupiter_mask_mobilelow from "../planet/compressed-assets/mobilelow/jupiter_mask.png";
import jupiter_texture_mobilelow from "../planet/compressed-assets/mobilelow/jupiter_texture.jpg";

import neptune_mask_mobilelow from "../planet/compressed-assets/mobilelow/neptune_mask.png";
import neptune_texture_mobilelow from "../planet/compressed-assets/mobilelow/neptune_texture.jpg";

import saturn_texture_mobilelow from "../planet/compressed-assets/mobilelow/saturn_texture.jpg";
import saturn_mask_mobilelow from "../planet/compressed-assets/mobilelow/saturn_mask.png";

import uranus_mask_mobilelow from "../planet/compressed-assets/mobilelow/uranus_mask.png";
import uranus_texture_mobilelow from "../planet/compressed-assets/mobilelow/uranus_texture.jpg";

export const loaderConfig = {
  mobilelow: [
    // ["earth_mask", earth_mask_mobilelow],
    // ["earth_texture", earth_texture_mobilelow],
    ["moon_mask", moon_mask_mobilelow],
    ["moon_texture", moon_texture_mobilelow],
    ["mars_mask", mars_mask_mobilelow],
    ["mars_texture", mars_texture_mobilelow],
    ["jupiter_mask", jupiter_mask_mobilelow],
    ["jupiter_texture", jupiter_texture_mobilelow],
    ["neptune_mask", neptune_mask_mobilelow],
    ["neptune_texture", neptune_texture_mobilelow],
    ["saturn_texture", saturn_texture_mobilelow],
    ["saturn_mask", saturn_mask_mobilelow],
    ["uranus_mask", uranus_mask_mobilelow],
    ["uranus_texture", uranus_texture_mobilelow],
  ],
  mobile: [
    // ["earth_mask", earth_mask_mobile],
    // ["earth_texture", earth_texture_mobile],
    ["moon_mask", moon_mask_mobile],
    ["moon_texture", moon_texture_mobile],
    ["mars_mask", mars_mask_mobile],
    ["mars_texture", mars_texture_mobile],
    ["jupiter_mask", jupiter_mask_mobile],
    ["jupiter_texture", jupiter_texture_mobile],
    ["neptune_mask", neptune_mask_mobile],
    ["neptune_texture", neptune_texture_mobile],
    ["saturn_texture", saturn_texture_mobile],
    ["saturn_mask", saturn_mask_mobile],
    ["uranus_mask", uranus_mask_mobile],
    ["uranus_texture", uranus_texture_mobile],
  ],
  desktop: [
    // ["earth_mask", earth_mask],
    // ["earth_texture", earth_texture],
    ["moon_mask", moon_mask],
    ["moon_texture", moon_texture],
    ["mars_mask", mars_mask],
    ["mars_texture", mars_texture],
    ["jupiter_mask", jupiter_mask],
    ["jupiter_texture", jupiter_texture],
    ["neptune_mask", neptune_mask],
    ["neptune_texture", neptune_texture],
    ["saturn_texture", saturn_texture],
    ["saturn_mask", saturn_mask],
    ["uranus_mask", uranus_mask],
    ["uranus_texture", uranus_texture],
  ],
};
import createPlanet from "../planet/planet";
import { planetConfig } from "../planet/planetConfigs";

export const planets = []

export const initializePlanets = (container) => {
  // planets.push(createPlanet(planetConfig("earth_texture", "earth_mask")))
  planets.push(createPlanet(planetConfig("moon_texture", "moon_mask")))
  planets.push(createPlanet(planetConfig("mars_texture", "mars_mask")))
  planets.push(createPlanet(planetConfig("jupiter_texture", "jupiter_mask")))
  planets.push(createPlanet(planetConfig("saturn_texture", "saturn_mask", 150, 0, 0)))
  planets.push(createPlanet(planetConfig("uranus_texture", "uranus_mask")))
  planets.push(createPlanet(planetConfig("neptune_texture", "neptune_mask")))

  planets.forEach(planet => {
    planet.x = 4000
    container.addChild(planet)
  })
}

export const defaultPlanetsAnimationProperties = () => [
  // { animated: false, readyForAnimation: false, point: 1 },
  { animated: false, readyForAnimation: false, point: 1.2 },
  { animated: false, readyForAnimation: false, point: 5 },
  { animated: false, readyForAnimation: false, point: 25 },
  { animated: false, readyForAnimation: false, point: 100 },
  { animated: false, readyForAnimation: false, point: 400 },
  { animated: false, readyForAnimation: false, point: 1000 },
];
